module.exports = __webpack_public_path__ + "media/images/career_camp/2023/perks_1-c5c8b5ddc71c3f816fa9e24b5d6e5fc0.svg";